export const formatDateWithShortYearAndMonth = (date) => {
    var y = date.substr(2, 2);
    var m = date.substr(5, 2);
    var d = date.substr(8, 2);

    var months = {
        '01': 'янв',
        '02': 'фев',
        '03': 'мар',
        '04': 'апр',
        '05': 'мая',
        '06': 'июн',
        '07': 'июл',
        '08': 'авг',
        '09': 'сен',
        '10': 'окт',
        '11': 'ноя',
        '12': 'дек',
    };

    return '' + d + ' ' + months[m] + ' ' + y;
}
